//-------------------Formula-----------------------------------//
$('#formula').slick({
    mobileFirst: true,
    variableWidth: false,
    slidesToShow: 1,
    dots: true,
    arrows: false,
    speed: 300,
    centerMode: false,
    slidesToShow: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                infinite: false,
                slidesToShow: 3,
                dots: false
            }
        }
    ]
});
//------------------ End formula-------------------------------//